import { SupabaseBackend, type Backend } from '@bhorosha/data';
import { DemoBackend } from './demoBackend';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

/** Supabase when configured (.env), otherwise a local demo. */
export const backend: Backend = url && key ? new SupabaseBackend(url, key) : new DemoBackend();
export type { Backend };
